module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av750-ff9af52a07ff957e393039600d6d656e.jpg";